import { LEGAL } from "@/lib/legal/config";
import { DISPLAY_TRANSLATION } from "@/lib/scripture/translation";

/**
 * 성경 본문이 나오는 곳(구절 팝업, 오늘의 말씀 카드)마다 전체 설명을 반복하지 않고,
 * 개인정보 처리방침·이용약관처럼 이 페이지 하나로 모아둔다. 다만 성명표시권 때문에
 * 본문이 나오는 자리에는 "번역본명 · 저작권 안내(이 페이지 링크)"라는 짧은 표시는
 * 그대로 남겨둔다 — 저작권 표시 자체를 아예 없애는 게 아니라, 긴 설명만 한 곳으로
 * 옮기는 것이다.
 */
export default function ScriptureCopyrightPage() {
  return (
    <>
      <div>
        <h1>성경 본문 저작권 안내</h1>
      </div>

      <p>
        서비스에 표시되는 성경 본문(<strong>{DISPLAY_TRANSLATION.name}</strong>)의 저작권은{" "}
        <strong>{DISPLAY_TRANSLATION.copyright}</strong>에 있습니다. 운영자는 사용 허락을 받은 범위 안에서
        본문을 그대로(임의로 자르거나 바꾸지 않고) 표시하며, 어디에 표시되든 이 출처를 함께 밝힙니다.
      </p>

      <ul>
        <li>번역본: {DISPLAY_TRANSLATION.name}</li>
        <li>저작권자: {DISPLAY_TRANSLATION.copyright}</li>
        <li>표시 위치: 노트 상세의 구절 팝업, 홈 화면의 오늘의 말씀</li>
      </ul>

      <p>
        성경 본문에 대한 문의나 이의가 있으면 대한성서공회({" "}
        <a className="underline underline-offset-4" href="https://www.bskorea.or.kr" target="_blank" rel="noreferrer">
          bskorea.or.kr
        </a>
        )로 연락하시거나, 아래 운영자 문의처로 알려주시면 확인 후 조치하겠습니다.
      </p>

      <p>
        운영자: {LEGAL.operatorName} / 이메일: {LEGAL.contactEmail}
      </p>
    </>
  );
}
